var MediatorCollector = {
  instance: function () {
    if (!MediatorCollector.instance) {
      MediatorCollector.instance = this;
    }
    return MediatorCollector.instance;
  },

  collectorStep: null,
  tagsCreated: new Map(),
  valueOnline: "",
  valueDay: "",
  valueWeek: "",
  valueMonth: "",
  valueHarvest: "",

  notify(sender, event) {
    switch (event) {
      case "init-step":
        this.collectorStep = sender
        break;

      case "insert-element":
        sendToCalc(sender)
        updateStatusCreatedTags()
        break

      case "load-calc":
        insertCalc(sender)
        updateStatusCreatedTags()
        break

      case "clean-collector":
        cleanCurrentAreaCalculate()
        updateStatusCreatedTags()
        break

      case "backspace-collector":
        backspaceCalculate()
        updateStatusCreatedTags()
        break

      case "update-form":
        updateForm(sender)
        break
    }
  }
}

let keys = ["operation-0", "operation-1", "operation-2", "operation-3", "operation-4", "operation-5"]
let keysAreaDrag = ["calculation-area-online", "calculation-area-day", "calculation-area-week", "calculation-area-month", "calculation-area-harvest"]
let keyAgragateValues = ["valueOnline", "valueDay", "valueWeek", "valueMonth", "valueHarvest"]
let keysRelative = ["(", ")", "+", "-", "*", "/"]

function updateStatusCreatedTags() {
  function wasUsed(tag, sentence){
    let values = sentence.split(" ")
    let result = false
    for (const token of values) {
      if(tag.trim() == token.split(":")[0].trim())
        result = true
    }
    return result
  }
  
  MediatorCollector.collectorStep.reloading = true
  MediatorCollector.collectorStep.tagsCreated.forEach(t => {
    let result = wasUsed(t.name, MediatorCollector.valueOnline)
    result = wasUsed(t.name, MediatorCollector.valueDay) || result
    result = wasUsed(t.name, MediatorCollector.valueWeek) || result
    result = wasUsed(t.name, MediatorCollector.valueMonth) || result
    result = wasUsed(t.name, MediatorCollector.valueHarvest) || result

    t.used = result
  })

  setTimeout(() => {
    MediatorCollector.collectorStep.reloading = false
  }, 50);
}

function getAreaCalculateActive() {
  let index = MediatorCollector.collectorStep.indexCalcType
  return keysAreaDrag[index]
}

function getAgregateValuesActive() {
  let index = MediatorCollector.collectorStep.indexCalcType
  return keyAgragateValues[index]
}

function sendToCalc(name) {
  let tag = MediatorCollector.tagsCreated.find(t => t.name == name)
  let tagToUpdate = MediatorCollector.collectorStep.tagsCreated.find(t => t.name == name)

  if (!tag && check.insertOperation(name)) {
    let index = keys.indexOf(name)
    let keyRelative = keysRelative[index];
    createOperation(keyRelative)
    return
  }
  else if (tag && check.insertTag(tag)) {
    if (tag.type == 0 || tag.type == 2)
      createTag(tag.name)
    else if (tag.type == 1)
      createTag(`${tag.name}:${tag.variables[0]}`)
    
    tag.used = true
    if(tagToUpdate){
      tagToUpdate.used = true
    }
  }
}

function insertCalc() {
  keyAgragateValues.forEach((valueCalculate, index) => {
    if (!MediatorCollector[valueCalculate]) return;

    let calculate = MediatorCollector[valueCalculate].split(" ")
    let area = keysAreaDrag[index]
    let el = document.getElementById(area);
    if(el)
      el.innerHTML = "";
    MediatorCollector[valueCalculate] = ""

    calculate.forEach(token => {
      if (keysRelative.includes(token)) {
        createOperation(token, area, valueCalculate)
      }
      else {
        createTag(token, area, valueCalculate)
      }
    });
  })
}

var check = {
  getLastElement() {
    let area = getAgregateValuesActive()
    let calc = MediatorCollector[area];
    var variables = calc.split(" ")
    return variables[variables.length - 1]
  },

  getRelativeTag(key) {
    let index = keys.indexOf(key)
    return keysRelative[index];
  },

  insertTag(tag) {
    let lastElement = this.getLastElement()
    let agregate = getAgregateValuesActive()
    let agregateCalc = MediatorCollector[agregate]

    if (!agregateCalc) return true // Se estiver iniciando um calculo
    if (!keysRelative.includes(lastElement) || lastElement == ")") {
      this.emitError(`Cálculo inválido:`, tag.name)
      return false
    }
    return true
  },

  insertOperation(key) {
    let operations = ["+", "-", "*", "/"]
    let agregate = getAgregateValuesActive()
    let agregateCalc = MediatorCollector[agregate];
    let step = ""
    let emit = (keyRelative, step) => {
      console.log('step ', step)
      this.emitError(`Cálculo inválido:`, keyRelative)
      return false
    }

    step = "Verifica a entrada incial de um operador inválido."
    if (!agregateCalc && key != "operation-0" && key != "operation-3") {
      console.log('step ', step)
      return false
    }

    var variables = agregateCalc.split(" ")
    let lastElement = variables[variables.length - 1]
    let keyRelative = this.getRelativeTag(key)

    step = "bloquear: (+, (*, (/";
    if (lastElement == "(" && (key == "operation-2" || key == "operation-4" || key == "operation-5")) return emit(keyRelative, step)

    step = "bloquear: +), *), /), -)";
    if (operations.includes(lastElement) && key == "operation-1") return emit(keyRelative, step)

    step = "Verifica a duplicidade de operadores"
    if (operations.includes(lastElement) && key != "operation-0" && key != "operation-1") return emit(keyRelative, step)

    step = "Verificando parenteses com ultimo valor não sendo aritimético"
    if (!operations.includes(lastElement) && key == "operation-0" && lastElement != "(" && lastElement != "") return emit(keyRelative, step)

    step = "Verifica a quantidade de parenteses parenteses"
    let left_parentheses = variables.filter(t => t.includes("("))
    let rigth_parentheses = variables.filter(t => t.includes(")"))
    if (left_parentheses.length <= rigth_parentheses.length && key == "operation-1") return emit(keyRelative, step)

    step = "Verifica parenteses vazio"
    let empty_parentheses = false
    variables.forEach(t => {
      if (t == "(" && key == "operation-1")
        empty_parentheses = true

      if (t != "(" && empty_parentheses)
        empty_parentheses = false
    })

    if (empty_parentheses) return emit(keyRelative, step)

    return true
  },

  emitError(msg, keyRelative) {
    let agregate = getAgregateValuesActive()
    let agregateCalc = MediatorCollector[agregate];
    MediatorCollector.collectorStep.showError(`${msg} [${agregateCalc + ' ' + keyRelative}]`)
  }
}

function cleanCurrentAreaCalculate() {
  let key = getAreaCalculateActive()
  let calculate = getAgregateValuesActive()

  document.getElementById(key).innerHTML = "";
  MediatorCollector[calculate] = ""
  MediatorCollector.tagsCreated.forEach(t => t.used == false)
  MediatorCollector.collectorStep.update()
}

function backspaceCalculate() {
  let calculate = getAgregateValuesActive()
  if (!MediatorCollector[calculate]) return;

  let key = getAreaCalculateActive()
  let parent = document.getElementById(key)
  let childrens = parent.childNodes
  parent.removeChild(childrens[childrens.length - 1])
  let teste = MediatorCollector[calculate]
  let calc = MediatorCollector[calculate].split("")
  calc.reverse()
  let indexStoped = 0
  for (let i in calc) {
    if ((calc[i] == " " || (calc.length - 1) == i) && indexStoped == 0)
      indexStoped = i
  }
  indexStoped++;
  let newCalc = "";
  for (let i = 0; i < (teste.length - indexStoped); i++) {
    newCalc += teste[i]
  }
  MediatorCollector[calculate] = newCalc
  MediatorCollector.collectorStep.update()
}

function createOperation(token, key, calculate) {
  let label = document.createElement("label")
  label.style["background-color"] = "#ff5b0080";
  setStyle(label)
  label.innerHTML = token;

  if (!key)
    key = getAreaCalculateActive()

  let el = document.getElementById(key)
  if(el)
    el.appendChild(label)

  if (!calculate)
    calculate = getAgregateValuesActive()

  MediatorCollector[calculate] += MediatorCollector[calculate] ? " " + token : token
  MediatorCollector.collectorStep.update()
}

function createTag(tag, key, calculate) {
  let label = document.createElement("label")
  label.style["background-color"] = "#00a39f80";
  setStyle(label)
  label.innerHTML = tag;

  if (!key)
    key = getAreaCalculateActive()
  let el = document.getElementById(key)
  if(el)
    el.appendChild(label)

  if (!calculate)
    calculate = getAgregateValuesActive()

  MediatorCollector[calculate] += MediatorCollector[calculate] ? " " + tag : tag
  MediatorCollector.collectorStep.update()
}

function setStyle(el) {
  el.style["min-width"] = "24px";
  el.style["text-align"] = "center";
  el.style["padding"] = "2px 6px";
  el.style["border"] = "1px solid #0001";
  el.style["border-radius"] = "4px";
  el.style["margin"] = "2px";
}

function updateForm(tag) {
  let tabs = document.querySelectorAll(".tabs>div>ul>li>a");
  if (tag.type == 0) {
    tabs[0].click()
    MediatorCollector.collectorStep.syntaxeSelected = null;
    setTimeout(() => {
      MediatorCollector.collectorStep.syntaxeSelected = tag.key.split(":")[0];
    }, 25);
    setTimeout(() => {
      MediatorCollector.collectorStep.nameTag = tag.name;
      MediatorCollector.collectorStep.variables = tag.variables
      
      if(tag.note){
        MediatorCollector.collectorStep.canShowPentagroServer = false;
        
        let split = tag.note.split("|");
        MediatorCollector.collectorStep.databasesOpcSelected = split[0]

        // Manter compatibilidade opc versão antiga
        if(split.length == 2)
          MediatorCollector.collectorStep.opcServerSelected = split[1]

        if(split[1] == "AUTO"){
          MediatorCollector.collectorStep.canShowPentagroServer = true;
          MediatorCollector.collectorStep.opcServerSelected = split[2]
        }

        if(split[1] == "INTEL")
          MediatorCollector.collectorStep.intelupProductionUnit = split[2]
          
          if(split[1] == "PISYS")
          MediatorCollector.collectorStep.piSytemFilter = JSON.parse(split[2])
      }
    }, 50);
  }
  else if (tag.type == 1) {
    tabs[1].click()
    MediatorCollector.collectorStep.nameConstant = tag.name;
    MediatorCollector.collectorStep.valueConstante = tag.variables[0]
  }
  else if (tag.type == 2) {
    tabs[2].click()
    MediatorCollector.collectorStep.indicatorSelected = tag.key
    MediatorCollector.collectorStep.indicatorValue = tag.name;
    MediatorCollector.collectorStep.valueConstante = tag.variables[0]
  }
}

export default MediatorCollector